/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as AppRouteImport } from "./routes/_app";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AppVenuesRouteImport } from "./routes/_app/venues";
import { Route as AppOperatorsRouteImport } from "./routes/_app/operators";
import { Route as AppDashboardRouteImport } from "./routes/_app/dashboard";
import { Route as AppAuditRouteImport } from "./routes/_app/audit";
import { Route as AppVenuesVenueIdRouteImport } from "./routes/_app/venues.$venueId";

const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AppVenuesRoute = AppVenuesRouteImport.update({
  id: "/venues",
  path: "/venues",
  getParentRoute: () => AppRoute,
} as any);
const AppOperatorsRoute = AppOperatorsRouteImport.update({
  id: "/operators",
  path: "/operators",
  getParentRoute: () => AppRoute,
} as any);
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AppRoute,
} as any);
const AppAuditRoute = AppAuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => AppRoute,
} as any);
const AppVenuesVenueIdRoute = AppVenuesVenueIdRouteImport.update({
  id: "/$venueId",
  path: "/$venueId",
  getParentRoute: () => AppVenuesRoute,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/login": typeof LoginRoute;
  "/audit": typeof AppAuditRoute;
  "/dashboard": typeof AppDashboardRoute;
  "/operators": typeof AppOperatorsRoute;
  "/venues": typeof AppVenuesRouteWithChildren;
  "/venues/$venueId": typeof AppVenuesVenueIdRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/login": typeof LoginRoute;
  "/audit": typeof AppAuditRoute;
  "/dashboard": typeof AppDashboardRoute;
  "/operators": typeof AppOperatorsRoute;
  "/venues": typeof AppVenuesRouteWithChildren;
  "/venues/$venueId": typeof AppVenuesVenueIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_app": typeof AppRouteWithChildren;
  "/login": typeof LoginRoute;
  "/_app/audit": typeof AppAuditRoute;
  "/_app/dashboard": typeof AppDashboardRoute;
  "/_app/operators": typeof AppOperatorsRoute;
  "/_app/venues": typeof AppVenuesRouteWithChildren;
  "/_app/venues/$venueId": typeof AppVenuesVenueIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/login"
    | "/audit"
    | "/dashboard"
    | "/operators"
    | "/venues"
    | "/venues/$venueId";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/login"
    | "/audit"
    | "/dashboard"
    | "/operators"
    | "/venues"
    | "/venues/$venueId";
  id:
    | "__root__"
    | "/"
    | "/_app"
    | "/login"
    | "/_app/audit"
    | "/_app/dashboard"
    | "/_app/operators"
    | "/_app/venues"
    | "/_app/venues/$venueId";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AppRoute: typeof AppRouteWithChildren;
  LoginRoute: typeof LoginRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app": {
      id: "/_app";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app/venues": {
      id: "/_app/venues";
      path: "/venues";
      fullPath: "/venues";
      preLoaderRoute: typeof AppVenuesRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/operators": {
      id: "/_app/operators";
      path: "/operators";
      fullPath: "/operators";
      preLoaderRoute: typeof AppOperatorsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dashboard": {
      id: "/_app/dashboard";
      path: "/dashboard";
      fullPath: "/dashboard";
      preLoaderRoute: typeof AppDashboardRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/audit": {
      id: "/_app/audit";
      path: "/audit";
      fullPath: "/audit";
      preLoaderRoute: typeof AppAuditRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/venues/$venueId": {
      id: "/_app/venues/$venueId";
      path: "/$venueId";
      fullPath: "/venues/$venueId";
      preLoaderRoute: typeof AppVenuesVenueIdRouteImport;
      parentRoute: typeof AppVenuesRoute;
    };
  }
}

interface AppVenuesRouteChildren {
  AppVenuesVenueIdRoute: typeof AppVenuesVenueIdRoute;
}

const AppVenuesRouteChildren: AppVenuesRouteChildren = {
  AppVenuesVenueIdRoute: AppVenuesVenueIdRoute,
};

const AppVenuesRouteWithChildren = AppVenuesRoute._addFileChildren(
  AppVenuesRouteChildren,
);

interface AppRouteChildren {
  AppAuditRoute: typeof AppAuditRoute;
  AppDashboardRoute: typeof AppDashboardRoute;
  AppOperatorsRoute: typeof AppOperatorsRoute;
  AppVenuesRoute: typeof AppVenuesRouteWithChildren;
}

const AppRouteChildren: AppRouteChildren = {
  AppAuditRoute: AppAuditRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppOperatorsRoute: AppOperatorsRoute,
  AppVenuesRoute: AppVenuesRouteWithChildren,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
